/**
 * Central brand configuration for Heinze Portal.
 */

export const brand = {
  appName: 'HeinzePool Portal',
  shortName: 'HeinzePool',
  logo: '/hp-logo_white.png' as string | null,
  logoSize: { width: 140, height: 36 },
} as const;

/**
 * Application version — update on each release.
 */
export const APP_VERSION = '1.5.0';

/**
 * Color palette - Dark Navy Blue matching Heinze Pool logo.
 */
export const brandColors = {
  50:  '#eef4ff',
  100: '#d9e6ff',
  200: '#bcd2ff',
  300: '#8eb5ff',
  400: '#5b8dd9',
  500: '#3b6bb5',
  600: '#1a4f8c',
  700: '#163d6e',
  800: '#143357',
  900: '#122b48',
  950: '#0c1c30',
} as const;

/**
 * Sidebar color scheme - Dark navy matching the Heinze Pool brand.
 */
export const sidebarColors = {
  background:       '#0f2240',
  headerBorder:     '#1a3660',
  brandText:        '#7cb9e8',
  linkText:         '#c8ddf0',
  linkHover:        '#1a3660',
  linkActiveBg:     '#163056',
  linkActiveBorder: '#5b9bd5',
  footerBorder:     '#1a3660',
  avatarBg:         '#3b82f6',
  roleText:         '#8faec8',
  menuBg:           '#1a3660',
  menuHover:        '#244878',
} as const;
